/// <amd-module name="Feed/Legacy/Actions/FeedSettings/DeleteFeedHandler" />
import { IFeedSettingsState } from "Feed/Legacy/Components/Settings/IFeedSettingsState";
import { IFeedDataService } from "Feed/Legacy/DataServices/FeedsDataService";

/**
 * User clicked on Delete button in Delete Feed Dialog
 */
export class DeleteFeedHandler {
    public static async handleAsync(state: IFeedSettingsState): Promise<void> {
        const feedDataService = state.pageContext.getService<IFeedDataService>("IFeedDataService");
        const feed = state.feed();
        const projectId = feed.project ? feed.project.id : null;
        await feedDataService.deleteFeedAsync(projectId, feed.id);
        return;
    }
}
